import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLNonNull,
  GraphQLID,
  GraphQLList,
  GraphQLBoolean,
  GraphQLInt
} from 'graphql'
import {
  ApplicationImportanceType,
  ApplicationImportance
} from './application-importance'
import { RouteCoveragePolicy } from '../../../components/organization-applications-settings-form'

interface Policy {
  readonly name: string
  readonly id: string
}

export interface OrganizationApplicationsSettings {
  readonly importance: ApplicationImportance
  readonly remediationPolicies: Policy[]
  readonly compliancePolicies: Policy[]
  readonly autoLicense: boolean
  readonly id: string
  readonly filterAppMostRecentSession: boolean
  readonly preventOnboardingFailingApplications: boolean
  readonly preventOnboardingFailingApplicationsBySession: boolean
  routeExpirationDays: number | null
  protectRuleEnv: string
  routeCoverageAbsolutePolicy: RouteCoveragePolicy | null
}

const applicationPolicyType = new GraphQLObjectType({
  name: 'ApplicationPolicy',
  fields: () => ({
    name: {
      type: new GraphQLNonNull(GraphQLString)
    },
    id: {
      type: new GraphQLNonNull(GraphQLID)
    }
  })
})

export const RouteCoverageAbsolutePolicy = new GraphQLObjectType({
  name: 'RouteCoveragePolicy',
  fields: () => ({
    id: {
      type: GraphQLID
    },
    name: {
      type: GraphQLString
    },
    coveragePercentage: {
      type: GraphQLInt
    },
    applicationImportances: {
      type: new GraphQLList(ApplicationImportanceType)
    },
    applicationIds: {
      type: new GraphQLList(GraphQLString)
    },
    enabled: {
      type: GraphQLBoolean
    },
    allApplications: {
      type: GraphQLBoolean
    }
  })
})

export const organizationApplicationsSettingsType = new GraphQLObjectType({
  name: 'OrganizationApplicationsSettings',
  description: '',
  fields: () => ({
    id: {
      description: 'The organization ID for the settings',
      type: new GraphQLNonNull(GraphQLID)
    },
    importance: {
      description: 'The default importance applied to a new application',
      type: ApplicationImportanceType
    },
    remediationPolicies: {
      description:
        'The remediation policies that are applied by default to new applications',
      type: new GraphQLNonNull(new GraphQLList(applicationPolicyType))
    },
    compliancePolicies: {
      description:
        'The compliance policies that are applied by default to new appications',
      type: new GraphQLNonNull(new GraphQLList(applicationPolicyType))
    },
    autoLicense: {
      description:
        'Whether or not licenses are automatically allocated to new applications',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    filterAppMostRecentSession: {
      description:
        'Whether or not application details are filtered by most recent session',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    preventOnboardingFailingApplications: {
      description:
        'Whether or not to prevent onboarding failing applications by app metadata',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    preventOnboardingFailingApplicationsBySession: {
      description:
        'Whether or not to prevent onboarding failing applications by session',
      type: new GraphQLNonNull(GraphQLBoolean)
    },
    routeExpirationDays: {
      description:
        'The number days to wait before expiring a route of an inactive application; zero and negative values indicate no expiration should happen',
      type: GraphQLInt
    },
    protectRuleEnv: {
      description: 'The environment to map assess rules to protect rules.',
      type: GraphQLString
    },
    routeCoverageAbsolutePolicy: {
      description: 'The route coverage absolute policy',
      type: RouteCoverageAbsolutePolicy
    }
  })
})
